const comHeader = (() => {
  

  const header = document.querySelector('header.header');

  if (window.matchMedia('(max-width: 769px)').matches) {

  }else{

    window.addEventListener('scroll', function () {
      var sH = window.scrollY;
      console.log(sH);
      if (sH >= 148) {
        header.classList.add('hScroll');
      } else {
        header.classList.remove('hScroll');
      }
    });
  }


})();
export default comHeader;